export default __webpack_public_path__ + "static/media/full mask.5419ca91.svg";